import React, {Component} from 'react';
import PropTypes from 'prop-types';

import './App.scss';

import Video from './Video';
import Timeline from './Timeline';
import Navigation from './Navigation';
import Popup from './Popup';
import Splash from './Splash';
import About from './About';

export default class App extends Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    render () {
        return (
            <div className="App">
                <About open={this.context.router.location.pathname.split('/').pop() === "about"} />
                <Timeline />
                <Video />
                <Popup />
                <Navigation />
                <Splash />
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/App.js